module.exports = __webpack_public_path__ + "static/media/81e827fdf825193402a93ff78c0c13e8.81e827fd.webp";